<template>
  <section class="h-full bg-white">
    <div class="pda-default bg-white">
      <!-- <div class="mgt-26 t-center">
            <img :src="brandLogo" class="login-logo">
        </div> -->
      <div
        class="t-center t-headline4"
        style="margin-top: -14px !important; margin-bottom: 0px"
      >
        <a
          class="material-icons mdc-top-app-bar__navigation-icon login-icon"
          style="margin-left: -14px !important"
          @click="brandSelectPage()"
          >close</a
        >
        {{ title }}

        <!-- {{ $t("286") }} -->
        <!-- {{ bradName }} -->
      </div>
      <div
        class="t-center"
        style="margin-top: 14px; margin-bottom: 19px; font-size: 1.168rem"
      >
        Visual Display
      </div>

      <div class="mgt-15">
        <form @submit.prevent="login" novalidate>
          <div class="email-wrap">
            <div class="email-left">
              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                id="userIdEl"
                ref="userIdEl"
                :class="
                  submitState && userIdInvalidCheck
                    ? 'mdc-text-field--invalid'
                    : ''
                "
              >
                <input
                  type="text"
                  class="mdc-text-field__input"
                  id="userId"
                  name="userId"
                  v-validate="'required'"
                  autocomplete="off"
                  @keydown="handleKeyPressDown"
                  :value="userId"
                  @input="(e) => handleInput(e, 'userId')"
                  v-lowercase
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                      E-mail
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
            </div>
            <div class="email-right">
              <!-- <label class="inputIcon " v-if="!isOther" > id="emailIdEl" ref="emailIdEl" :class="submitState && userIdInvalidCheck ? 'mdc-text-field--invalid' : ''"-->
              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full inputIcon"
                :class="isOther ? 'd-none' : ''"
              >
                <span class="icon">@</span>
                <select
                  id="emailOptions"
                  class="form-control"
                  @change="setIsOther"
                  :value="userId1"
                  v-lowercase
                >
                  <option value="samsung.com">samsung.com</option>
                  <option value="partner.samsung.com">
                    partner.samsung.com
                  </option>
                  <option value="others">Others</option>
                </select>
                <!-- </label> -->
              </div>
              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full inputIcon"
                id="userId2El"
                ref="userId2El"
                :class="[
                  submitState && userId2InvalidCheck
                    ? 'mdc-text-field--invalid'
                    : '',
                  !isOther ? 'd-none' : '',
                ]"
              >
                <span class="icon">@</span>
                <input
                  type="text"
                  class="mdc-text-field__input"
                  id="userId2"
                  name="userId2"
                  v-validate="rules"
                  @keydown="handleKeyPressDown"
                  :value="userId2"
                  @input="(e) => handleInput(e, 'userId2')"
                  v-lowercase
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                      Others
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                <span v-show="submitState && userId2InvalidCheck">
                  {{ $t("107") }}
                  <!-- * 비밀번호를 입력하세요. -->
                </span>
              </div>
            </div>
          </div>

          <div
            class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-7"
            id="passwordEl"
            ref="passwordEl"
            :class="
              submitState && passwordInvalidCheck
                ? 'mdc-text-field--invalid'
                : ''
            "
          >
            <i class="material-icons mdc-text-field__icon"></i>
            <input
              type="password"
              class="mdc-text-field__input"
              v-model="password"
              id="password"
              name="password"
              v-validate="'required'"
              @keydown="handleKeyPressDown"
            />

            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch">
                <label for="tf-outlined" class="mdc-floating-label">
                  {{ $t("288") }}
                  <!-- Password -->
                </label>
              </div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div>
          <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
            <span v-show="submitState && passwordInvalidCheck">
              {{ $t("107") }}
              <!-- * 비밀번호를 입력하세요. -->
            </span>
          </div>

          <div class="mgt-7">
            <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
            >
              {{ $t("289") }}
              <!-- 로그인  -->
            </button>
          </div>

          <div class="header-card mdc-card mdc-elevation--z3 bg-white mgt-16">
            <div class="mdc-form-field">
              <div class="mdc-checkbox">
                <input
                  type="checkbox"
                  class="mdc-checkbox__native-control"
                  id="checkbox-1"
                  v-model="checkBox"
                />
                <div class="mdc-checkbox__background">
                  <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                    <path
                      class="mdc-checkbox__checkmark-path"
                      fill="none"
                      d="M1.73,12.91 8.1,19.28 22.79,4.59"
                    />
                  </svg>
                  <div class="mdc-checkbox__mixedmark"></div>
                </div>

                <div class="mdc-checkbox__ripple"></div>
              </div>
              <label for="checkbox-1">{{ $t("1911") }} </label>
            </div>
          </div>
          <!-- <div class="mgt-16">
                    <button class="mdc-button mdc-button--raised w-full btn-big btn-white" type="button" @click="$router.push('/home')">
                        {{$t('290')}} -->
          <!-- 나중에 하기  -->
          <!-- </button>
                </div> -->
        </form>

        <div class="t-body4">
          <div class="t-color-blue1 mgt-21">
            <router-link to="/findid">
              {{ $t("291") }}
              <!-- 아이디를 잊으셨나요?  -->
            </router-link>
            <span class="t-color-gray1">
              <!-- 혹은  -->
              {{ $t("292") }}
            </span>
            <router-link to="/findpw">
              <!-- 비밀번호를 잊으셨나요? -->
              {{ $t("293") }}
            </router-link>
          </div>

          <div class="t-color-gray1 mgt-16">
            <!-- 계정이 없으신가요?  -->
            {{ $t("294") }}
            <router-link to="/join2" class="t-color-red3">
              {{ $t("299") }}

              <!-- 가입하기 -->
            </router-link>
          </div>

          <div class="t-color-gray1 mgt-16">
            <!-- 체크인 시 서비스 정책에 동의하는 것입니다. -->
            {{ $t("295") }}
          </div>

          <div class="t-color-blue1 mgt-5">
            <router-link to="/terms">
              {{ $t("296") }}
              <!-- 이용약관 -->
            </router-link>
            <span class="t-color-gray1">
              {{ $t("297") }}
            </span>
            <router-link to="/privacy">
              {{ $t("298") }}
              <!-- 개인정보취급방침 -->
            </router-link>
          </div>

          <!-- TODO : 추후 다국어 코드 처리 필요 -->
          <div class="t-color-gray1 mgt-32">
            <div
              class="t-color-gray1 f-size13"
              v-html="returnNoticeText('TITLE')"
            ></div>
            <div
              class="t-color-gray1 f-size11"
              v-html="returnNoticeText()"
            ></div>
          </div>
        </div>
        <div v-if="socialAuth == true" class="mgt-16">
          <hr class="divider" />
          <div class="mgt-19 t-center">
            <button
              class="mdc-button btn-sns-sign"
              @click.prevent="socialLoginAuth('google')"
            >
              <img
                src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/2.6.51/static/media/google-logo.c21ca9d1.svg"
              />
            </button>
            <button
              class="mdc-button btn-sns-sign"
              @click.prevent="socialLoginAuth('facebook')"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/c/c2/F_icon.svg"
              />
            </button>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </section>
</template>

<script>
/**
 * 로그인 컴포넌트(sign in main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import firebase from "firebase";
import { mapMutations } from "vuex";
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";

import loginApi from "@/api/loginApi.js";
import brandApi from "@/api/brandApi.js";
import socialApi from "@/api/socialApi.js";
import eventApi from "@/api/eventApi.js";

import { commonMixin } from "@/mixins/common.js";

import { captureApiError } from "@/utils/sentryApiHandler.js";

import { setUserLanguage } from "@/translations/i18nSetup";

export default {
  name: "signin",
  mixins: [commonMixin],
  data() {
    return {
      isOther: false,
      userId: "",
      userId1: "",
      userId2: "",
      password: "",
      socialType: "",
      socialToken: "",
      rPath: "",
      stateLogin: false,
      submitState: false,
      userIdTextField: null,
      passwordTextField: null,
      userId2TextField: null,
      redirectPath: "/login",
      snackbar: null,
      //brandLogo: localStorage.brandLogo,
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      socialAuth: false,
      title: null,
      bradName: localStorage.getItem("brandName"),
      checkBox: false,
      device_type: null,
      checkToken: null,
    };
  },

  computed: {
    isTabType() {
      return this.tabType;
    },

    rules() {
      let rulesExp = "";
      return (rulesExp += this.isOther ? "required" : "");
    },

    // UserId validation check
    userIdInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("userId")) {
          returnValue = true;
        } else {
          returnValue = false;
        }
      }
      this.userIdTextField.valid === !returnValue
        ? ""
        : (this.userIdTextField.valid = !returnValue);
      return returnValue;
    },

    // password validation check
    passwordInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("password")) {
          returnValue = true;
        } else {
          returnValue = false;
        }
      }
      this.passwordTextField.valid === !returnValue
        ? ""
        : (this.passwordTextField.valid = !returnValue);
      return returnValue;
    },

    userId2InvalidCheck() {
      //alert('p')
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("userId2")) {
          returnValue = true;
        } else {
          returnValue = false;
        }
      }
      this.userId2TextField.valid === !returnValue
        ? ""
        : (this.userId2TextField.valid = !returnValue);
      return returnValue;
    },
  },

  created() {
    localStorage.removeItem("popupRedirect1");

    // Redirect URL
    this.redirectPath = this.$route.query.redirectPath || "/home";
    this.title = localStorage.getItem("brandName") || this.$t("286");
    this.device_type =
      !localStorage.getItem("deviceOS") ||
      localStorage.getItem("deviceOS") === "undefined" ||
      localStorage.getItem("deviceOS") === "null"
        ? "WEB"
        : localStorage.getItem("deviceOS");
  },

  mounted() {
    setUserLanguage().then(() => {
      console.log("Login > setUserLanguage");
    });

    this.setMaterialUi();

    // 브랜드 설정 소셜 로그인 사용 여부 확인(Check social login is enabled)
    const brandCode = localStorage.getItem("brandCode");
    if (brandCode) {
      brandApi
        .brandInfo()
        .then((response) => {
          this.socialAuth = response.data.data.socialAuth;
        })
        .catch((error) => {
          console.log("Login BrandInfo Error : ", error);
          captureApiError({
            err,
            frontRoute: this.$route,
            frontData: this.$data,
          });
        });
    }

    this.userId = this.getCookie("email");
    this.userId1 = this.getCookie("email1");
    this.userId2 = this.getCookie("email2");
    if (this.userId1 === "others") {
      this.isOther = true;
    }

    if (this.getCookie("email")) {
      this.checkBox = true;
      setTimeout(function () {
        document.getElementById("userId").focus();
        document.getElementById("userId2").focus();
      }, 900);
    }
  },

  methods: {
    brandSelectPage() {
      this.$router.push("/brandselect");
    },

    // Store Mutations define
    ...mapMutations("join", [
      "SET_JOINSTART",
      "SET_SOCIAL_LINK",
      "SET_NAME_FIRST",
      "SET_NAME_LAST",
      "SET_NAME_FULL",
      "SET_LOGINID",
      "SET_SOCIAL_ID",
      "INIT_JOIN_STORE",
    ]),

    setIsOther(e) {
      this.userId1 = e.target.value;
      if (this.userId1 === "others") {
        this.isOther = true;
      }
    },

    setMaterialUi() {
      this.userIdTextField = new MDCTextField(
        document.getElementById("userIdEl")
      );
      this.passwordTextField = new MDCTextField(
        document.getElementById("passwordEl")
      );
      this.userId2TextField = new MDCTextField(
        document.getElementById("userId2El")
      );

      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );

      // 자동 유효성 체크 제거(Automatic Validation Remove)
      this.userIdTextField.useNativeValidation = false;
      this.passwordTextField.useNativeValidation = false;
      this.userId2TextField.useNativeValidation = false;
    },

    // set parameter
    setParams(loginType) {
      let params = null;

      if (loginType === "social") {
        params = {
          userId: "",
          password: "",
          device: {
            type: this.device_type !== null ? this.device_type : "WEB",
          },
          social: {
            // type: this.socialType,
            type: "firebase",
            token: this.socialToken,
          },
        };
      } else {
        params = {
          userId: this.userId2
            ? this.userId + "@" + this.userId2
            : this.userId + "@" + this.userId1,
          password: this.password,
          device: {
            type:
              this.device_type !== null
                ? this.device_type.toUpperCase()
                : "WEB",
          },
        };
      }
      return params;
    },

    handleKeyPressDown(e) {
      const keyCode = e.keyCode || e.which;
      if (keyCode === 32) {
        e.preventDefault();
      }
    },

    // click login button
    login(loginType) {
      if (loginType === "social") {
        this.callLoginApi(loginType);
      } else {
        this.$validator.validateAll().then((resultValid) => {
          this.submitState = true;
          if (resultValid) {
            if (this.checkBox) {
              this.setCookie("email", this.userId);
              this.setCookie("email1", this.userId1);
              this.setCookie("email2", this.userId2);
            }
            this.callLoginApi(loginType);
          } else {
            this.focusFirstInvalidElement();
          }
        });
      }
    },

    setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + 3 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    callLoginApi(loginType) {
      let params = this.setParams(loginType);
      loginApi
        .login(params)
        .then((response) => {
          let responseData = response.data.data;
          let changePasswordRequest = responseData.changePasswordRequest;
          let reIssueChangePassword = responseData.reIssueChangePassword;
          let emailAuth = responseData.emailAuth;
          let dormancy = responseData.dormancy;
          let responsibilityAuth = responseData.responsibilityAuth;
          let termsAgree = responseData.termsAgree;
          localStorage.setItem("userParams", JSON.stringify(params));
          loginApi.setAuthInHeader(responseData.token);
          this.getForumAuth();
          this.getEventAuth();

          if (dormancy === true) {
            this.$alert({
              title: this.$t("824"),
              content:
                this.$t("825") +
                " " +
                this.$t("826") +
                "<br>" +
                this.$t("827", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("828", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("829"),
            })
              .then(() => {
                this.$router.push("/login");
              })
              .catch(() => {
                this.$router.push("/login");
              });
          } else if (termsAgree === false) {
            this.$router.push("/termsagree");
          } else if (emailAuth === false) {
            this.$confirm({
              title: this.$t("804"),
              content: this.$t("805") + " " + this.$t("806"),
              accept: this.$t("835"),
              cancel: this.$t("834"),
            })
              .then(() => {
                this.$router.push("/emailvarification");
              })
              .catch(() => {
                this.$router.push("/login");
              });
          } else if (changePasswordRequest === true) {
            this.$router.push({ name: "MemberChangePassword" });
          } else if (reIssueChangePassword === true) {
            this.$router.push({ name: "MemberReIssueChangePassword" });
          } else if (responsibilityAuth === false) {
            this.$alert({
              title: this.$t("830"),
              content: this.$t("831") + " " + this.$t("832"),
              accept: this.$t("833"),
            })
              .then(() => {
                this.$router.push("/verificationcode");
              })
              .catch(() => {
                this.$router.push("/login");
              });
          } else {
            loginApi.setAuthInHeader(responseData.token);
            this.callPushNotification(); //save fbtoken in DB
            this.$router.push(this.redirectPath);
          }

          //
        })
        .catch((err) => {
          console.log("LOGIN FLOW ERROR : ", err);
          const responseData = err.response.data.meta;
          if (responseData.errCode === 1201) {
            //관리자 승인 대기중(Waiting for administrator approval)
            // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
            //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1202) {
            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1204) {
            this.$alert({
              title: this.$t("1482"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1483") +
                "<br>" +
                this.$t("1484", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("1485", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("1486"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1206) {
            // 정지처리
            this.$alert({
              title: this.$t("S20096"),
              content:
                this.$t("S20097") +
                "<br>" +
                this.$t("S20098", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("S20099", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("S20100"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1105) {
            this.$alert({
              content: this.$t("1875"),
              accept: this.$t("1876"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1335) {
            //아이디 계정 일시 정지(Suspend Account)
            // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
            this.$snackOpen({
              contents: this.$t("323"),
              btnDisplayYN: false,
            }).then(() => {});
          } else {
            if (loginType === "social") {
              //소셜 로그인 정보 없을 때(No social login information)
              this.$confirm({
                title: this.$t("300"), //'잘못된 로그인 정보' ,
                content: this.$t("301"), //'가입된 SNS 계정이 아닙니다. 이 SNS 계정으로 회원 가입하시겠습니까?'
                accept: this.$t("304"),
                cancel: this.$t("303"),
              })
                .then(() => {
                  this.SET_JOINSTART(true);
                  this.SET_NAME_FIRST(this.socialFirstName);
                  this.SET_NAME_LAST(this.socialLastName);
                  this.SET_NAME_FULL(this.socialFullName);
                  this.SET_SOCIAL_LINK({
                    type: "firebase",
                    token: this.socialToken,
                  });
                  this.SET_SOCIAL_ID(this.socialEmail);
                  this.SET_LOGINID(this.socialEmail);
                  this.$router.push({
                    name: "Join2Policy",
                    query: {
                      type: "social",
                    },
                  });
                })
                .catch(() => {
                  this.signOutFirebase();
                });
            } else {
              // this.$snackOpen({contents:'올바르지 않은 로그인 정보입니다.'}).then(() => {})
              this.$snackOpen({
                contents: this.$t("356"),
                btnDisplay: this.$t("357"),
              }).then(() => {});
            }
          }

          captureApiError({
            err,
            frontRoute: this.$route,
            frontData: this.$data,
          });
        });
    },

    signOutFirebase() {
      firebase.auth().signOut();
    },

    socialLoginAuth(socialType) {
      let provider = null;
      this.socialType = socialType;

      if (socialType === "google") {
        provider = new firebase.auth.GoogleAuthProvider();
      } else if (socialType === "facebook") {
        provider = new firebase.auth.FacebookAuthProvider();
      }

      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          let providerUserInfo = null;
          providerUserInfo = result.additionalUserInfo.profile;

          if (socialType === "google") {
            this.socialFirstName = providerUserInfo.family_name;
            this.socialLastName = providerUserInfo.given_name;
            this.socialFullName = providerUserInfo.name;
            this.socialEmail = providerUserInfo.email;
          } else if (socialType === "facebook") {
            this.socialFirstName = providerUserInfo.first_name;
            this.socialLastName = providerUserInfo.last_name;
            this.socialFullName = providerUserInfo.name;
            this.socialEmail = providerUserInfo.email;
          }

          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              this.socialToken = idToken;
              this.login("social");
            })
            .catch(function (err) {
              captureApiError({
                err,
                frontRoute: this.$route,
                frontData: this.$data,
              });
            });
        })
        .catch(function (err) {
          captureApiError({
            err,
            frontRoute: this.$route,
            frontData: this.$data,
          });
        });
    },

    focusFirstInvalidElement() {
      let invalidElementName = Object.keys(this.errors.collect())[0];
      this.$refs[`${invalidElementName}`].focus();
    },

    returnNoticeText(type) {
      if (type === "TITLE") {
        return `Notice to California Residents`;
      } else {
        return `
        If you are a California resident, for more information about your privacy rights, please see the California Consumer Privacy Statement section of the Samsung Privacy Policy for the U.S., available at: <a href="https://www.samsung.com/us/account/privacy-policy/california">https://www.samsung.com/us/account/privacy-policy/california.</a> To submit a privacy rights request in connection with the Business Services subject to this Privacy Policy, please Contact [<a href="mailto:">vdstar@samsung.com</a>]
        `;
      }
    },

    async getForumAuth() {
      try {
        const result = await socialApi.bordList({ bid: "sns" });
        if (!result || !result.data.data) return;
        localStorage.setItem("noForum", result.data.data.length === 0);
      } catch (err) {
        console.log("Get forum auth error : ", err);
        captureApiError({
          err,
          frontRoute: this.$route,
          frontData: this.$data,
        });
      }
    },

    async getEventAuth() {
      try {
        const result1 = await eventApi.boardInfo({ boardName: "BOARD1" });
        const result2 = await eventApi.boardInfo({ boardName: "BOARD2" });
        const result1Auth = result1.data.data.boardAuth;
        const result2Auth = result2.data.data.boardAuth;
        if (result1Auth === false && result2Auth === false) {
          localStorage.setItem("noEvent", true);
        } else {
          localStorage.setItem("noEvent", false);
        }
      } catch (err) {
        console.log("Get event auth err : ", err);
        captureApiError({
          err,
          frontRoute: this.$route,
          frontData: this.$data,
        });
      }
    },

    handleInput(e, type) {
      const key = type === "userId" ? "userId" : "userId2";
      this[key] = e.target.value;
    },
  },
};
</script>
<style scoped>
.mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  background: #2d6dcc;
  border-color: #2d6dcc;
}

.mdc-checkbox__background {
  border-width: 1px;
  border-color: #818181;
}
.emailInput {
  display: none;
}
.email-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
}
.email-left {
  flex: 0 0 38.5%;
  padding-left: 5px;
  padding-right: 5px;
}
.email-right {
  flex: 0 0 61.5%;
  padding-left: 5px;
  padding-right: 5px;
}
.d-none {
  display: none;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  padding: 15px 16px 18px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: 1rem;
  padding-left: 1.25rem;
}
.inputIcon {
  position: relative;
}
.icon {
  position: absolute;
  left: 10px;
  top: 16px;
  z-index: 99;
}
.mdc-text-field {
  width: 100%;
}
.inputIcon input {
  padding-left: 1.5rem !important;
}
.inputIcon .mdc-notched-outline__leading {
  width: 20px;
}

.mdc-checkbox__background::before {
  background-color: initial;
}

.mdc-checkbox__native-control:enabled:checked
  ~ .mdc-checkbox__background::before {
  background-color: var(--mdc-theme-secondary, #546e7a);
  animation-name: example;
  animation-duration: 2s;
  animation-fill-mode: forwards;
}

@keyframes example {
  100% {
    background-color: white;
  }
}

.f-size11 {
  font-size: 11px;
}

.f-size13 {
  font-size: 13px;
}
.login-icon {
  color: #2d6dcc !important;
}
</style>
